// extracted by mini-css-extract-plugin
export default {"iframeView":"IframeView_iframeView__2O1KY"};